import React, {useEffect} from "react";
import tokenStorage from '../../utils/tokenStorage';
import {SocialLogin} from "@offline/components/SignIn/SocialLogin";
import moment from "moment";

const DiffLoginMessage = ({externalLoginEnabled, internalLoginEnabled, eventName, timeStart, $locale, hasSsoLogin}) => {
    if (!externalLoginEnabled) {
        return null;
    }

    if (hasSsoLogin && !internalLoginEnabled) {
        return (
            <>
                <h2 className="auth-internal-subtitle">
                    {$locale.get('auth.login.submit')}
                </h2>
                <p>{$locale.get('auth.sso.authText')}</p>
            </>
        );
    }

    if (internalLoginEnabled) {
        return (
            <p>{hasSsoLogin ? $locale.get('auth.sso.loginText') : $locale.get('auth.login.email.title')}</p>
        );
    }

    const eventTimeStart = moment.unix(timeStart).format('LLL') + ' (UTC' + moment.unix(timeStart).format('Z') + ')';
    return (
        <div className="auth-container-titles">
            <h1>{eventName}</h1>
            <p>{$locale.get('ticketAuth.timeStart', {datetime: eventTimeStart})}</p>
            <p>{$locale.get('ticketAuth.header')}</p>
            {/*<p>{$locale.get('auth.login.social.title')}</p>*/}
        </div>
    );
}

export default (
    {
        $locale,
        services,
        eventKey,
        eventName,
        timeStart,
        ssoIconUrl,
        participationType = 'online',
        internalLoginEnabled,
        isSsoAuthOnly,
    }) => {
        
    useEffect(() => {
        const messageHandler = (e) => {
            try {
                const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
                if (data?.login?.token) {
                    tokenStorage.set(data.login.token);
                }
            } catch (e) {}
        }

        window.addEventListener('message', messageHandler);

        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, []);

    if (0 === services.length) {
        return null;
    }

    return (
        <div className="auth-container auth-container--xs">
            <DiffLoginMessage
                $locale={$locale}
                internalLoginEnabled={internalLoginEnabled}
                externalLoginEnabled={services?.length > 0}
                eventName={eventName}
                timeStart={timeStart}
                hasSsoLogin={services.includes('sso')}
            />
            <div>
                {services
                    .map((name) => (
                        <SocialLogin
                            key={name}
                            name={name}
                            eventKey={eventKey}
                            ssoIconUrl={ssoIconUrl}
                            participationType={participationType}
                            $locale={$locale}
                            isSsoAuthOnly={isSsoAuthOnly}
                        />
                    ))}
            </div>
        </div>
    );
}
